__webpack_require__.p = "https://uat.repo.byonde.asia/";